module.exports = __webpack_public_path__ + "static/img/product_7.5b495b8d.png";